import React, { PureComponent } from 'react';
import {
  ComposedChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer, Area, Line, Bar
} from 'recharts';



class StatusChart extends PureComponent {

	render () {
  	return (
      <ResponsiveContainer height={300} width='100%'>
        <ComposedChart
          width={600} 
          height={300} 
          data={this.props.data}
          margin={{top: 20, left: 30}}>
          <CartesianGrid strokeDasharray="3 3"/>
          <XAxis dataKey="Fecha" label={{ value: 'Fecha', position: 'insideBottomRight', offset: 0 }}/>
          <YAxis />
          <Tooltip/>
          <Legend />
            <Bar type="monotone" dataKey="BOGOTANORTE" fill="#CD5C5C" stroke="#CD5C5C" stackId="a"/>
            <Bar type="monotone" dataKey="BOGOTASUR" fill="#FF4500" stroke="#FF4500" stackId="a"/>
            <Bar type="monotone" dataKey="CARIBE" fill="#9ACD32" stroke="#9ACD32" stackId="a"/>
            <Bar type="monotone" dataKey="CENTRO" fill="#6495ED" stroke="#6495ED" stackId="a"/>
            <Bar type="monotone" dataKey="OCCIDENTE" fill="#00008B" stroke="#00008B" stackId="a"/>
            <Line type="monotone" dataKey="Total" stroke="#000000" />
        </ComposedChart>
      </ResponsiveContainer>
    );
  }
}

export default StatusChart;
